// Kindle Research Pro - Variant D: Trial Expired
import React from 'react';
import { Layout } from '../Layout';

export default function KindleVariantDExpired({ PaywallHero, sharedProps }) {
  return (
    <Layout>
      <div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-purple-50">
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-2xl mx-auto text-center">
            <div className="text-6xl mb-6">&#x23F0;</div>
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Your Trial Has Expired</h1>
            <p className="text-xl text-gray-600 mb-8">
              Your 7-day free trial of Kindle Research Pro has ended. 
              Subscribe now to continue finding profitable niches!
            </p>
            <PaywallHero 
              variant="D_expired"
              {...sharedProps}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
}
